import Vue from 'vue'
import toastDom from './toast.vue'
let ToastObj = Vue.extend(toastDom)
let instance
const toast = function (options) {
  // 如果存在toast，并且
  if (instance && instance.isShow) return
  options = options || {}
  instance = new ToastObj({
    data: options
  })
  // 渲染
  instance.vm = instance.$mount('#toast')
  instance.vm.toastShow = true
}
export default toast



// WEBPACK FOOTER //
// ./src/toast/toast.js